module.exports = __webpack_public_path__ + "static/media/bonus1@2x.01961696.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_230/imgs/bonus1@2x.png
// module id = 1764
// module chunks = 0